import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { useState, useEffect, Fragment, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { setDialog, setProductPopup } from '../store/api/GetAllProduct';
import { applyService, getService, getMessageList, addNewMessage, deleteMessage } from "../store/api/ServiceAPI";
import { getAllProvinces, getCityList, getZoneList } from '../store/api/LocationAPI';
import { useDispatch, useSelector } from "react-redux";
import ModalProducts from "../Common/ModalProducts";
import Loader from 'react-loader-spinner';
import { CheckLg, List, GeoAltFill, Command, PlusSquare, Trash } from 'react-bootstrap-icons';
import { Button, Form, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker2';
import ModalMap from '../Components/ModalMap';
import { setMapPop, setSerialHistoryPopup } from '../store/api/Modals';
import momentJalaali from "moment-jalali";
import ModalSerialHistory from '../Components/ModalSerialHistory';
import { getCutomerByID } from '../store/api/CustomerApi';
const AddEditCustomerService = () => {
    const dispatch = useDispatch();
    const message = useRef('');
    const gDate = useRef({});
    const history = useHistory();
    const [pending, setPending] = useState(false);
    const [gEndDate, setEndDate] = useState('');
    const [newSerial, setNewSerial] = useState('');
    const locationCmbClicked = useRef(false);
    const { serviceID, serviceType, customerID } = useParams();
    const { service, messageList } = useSelector(state => { return { service: state.service.serviceInfo, messageList: state.service.serviceMessageList } });
    const { provinceList, cityList, zoneList, currentLocation } =
        useSelector(state => {
            return {
                provinceList: state.locationDataReducer.provinceList,
                cityList: state.locationDataReducer.cityList,
                zoneList: state.locationDataReducer.zoneList,
                currentLocation: state.locationDataReducer.currentLocation
            }
        });
    const customer = useSelector(state => state.customerDataReducer.currentCustomer)
    const { settings } = useSelector(state => { return { settings: state.SystemSettingsReducer.systemSettings } });
    const productGrouppingType = settings && settings.find(s => s.SettingName === "ProductGrouppingType") ? settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue : 1;
    const serialIsEnglish = settings && settings.find(s => s.SettingName === "Services_ProductSerial_IsEnglish")?.SettingValue.toLowerCase() === "true";
    const { register, handleSubmit, errors } = useForm();
    const [selectedProduct, selectProduct] = useState({});
    const onProvinceChanged = (provinceID) => {
        locationCmbClicked.current = true;
        dispatch(getCityList(provinceID));
        dispatch(getZoneList());
    }
    const onCityChanged = (cityID) => {
        locationCmbClicked.current = true;
        dispatch(getZoneList(cityID));
    }
    useEffect(() => {
        dispatch(getAllProvinces());

    }, []);
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        if (Number(serviceID) > 0) {
            dispatch(getService(serviceType, serviceID));
            dispatch(getMessageList(serviceType, serviceID))
        }
        else if (!customer || !customer.ID) {
            dispatch(getCutomerByID(customerID));
        }
    }, []);
    const calcG_TimeInMonth = (date, isEnd) => {
        if ((isEnd && (!gDate.current.StartDate || gDate.current.StartDate === '')) || (!isEnd && (!gDate.current.EndDate || gDate.current.EndDate === ''))) {
            return;
        }
        const endDate = isEnd ? new Date(date) : new Date(gDate.current.EndDate);
        const startDate = isEnd ? new Date(gDate.current.StartDate) : new Date(date);
        const startDateutc = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const endDateutc = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
        const month = 1000 * 60 * 60 * 24 * 30;
        //selectedProduct.GuaranteeTimeInMonth = Math.round((endDateutc - startDateutc) / month);
    }
    const addMonth = (month) => {
        if (gDate.current.StartDate && gDate.current.StartDate !== '') {
            const startDate = new Date(gDate.current.StartDate);
            const endDate = startDate.setMonth(startDate.getMonth() + Number(month));
            gDate.current.EndDate = startDate.toISOString().split('T')[0];
            selectedProduct.GuaranteeTimeInMonth = month;
            setEndDate(gDate.current.EndDate);
        }
    }
    const showSerialHistory = () => {
        const setData = (item) => {
            selectProduct(item);
            setEndDate(item.GuaranteeEndDate);
        }
        dispatch(setSerialHistoryPopup({ show: true, onSetData: setData }))
    }
    const changeSerial = (serial) => {
        selectedProduct.SerialNumber = serial;
        setNewSerial(serial);
    }
    const changeCardNo = (cardNo) => {
        selectedProduct.GuaranteeCardNo = cardNo;
        setNewSerial(cardNo);
    }
    const showCommand = () => {
        history.push(`/CRM/Commands/0/${serviceID}/${serviceType}`);
    }
    const addMessage = () => {
        if (message.current === '') {
            return;
        }
        let data = {};
        data.ServiceID = serviceID;
        data.ServiceType = serviceType;
        data.MessageBody = message.current;
        dispatch(addNewMessage(data, () => { dispatch(getMessageList(serviceType, serviceID)) }));
    }
    const onSubmit = (data) => {
        data.ProductId = Number(data.ProductId);
        data.Latitude = currentLocation?.lat;
        data.Longtitude = currentLocation?.lng;
        data.CustomerID = customerID;
        if (gDate.current.StartDate && gDate.current.EndDate) {
            data.GuaranteeStartDate = gDate.current.StartDate;
            data.GuaranteeEndDate = gDate.current.EndDate;
        }
        if (Number(serviceID) > 0) {
            data.ServiceID = serviceID;
        }
        dispatch(applyService(data, () => {
            history.goBack();
        }))
    }

    return (
        <Fragment>
            <div className="container-fluid mt-1">
                <br />
                <ModalProducts productGrouppingType={productGrouppingType} />
                <ModalSerialHistory serialIsEnglish={serialIsEnglish} />
                {(service === "PENDING" || customer === "PENDING") && <Loader type="BallTriangle" color="red" height={50} width={50} />}
                {service !== "PENDING" && customer !== "PENDING" &&
                    <div className="card">
                        <div className="card-header headerStyle"> ثبت سرویس </div>
                        <div className="card-body bodyStyle">
                            <ModalMap
                                location={{
                                    lat: service && service.Latitude ? service.Latitude : (customer && customer.Latitude) ? customer.Latitude : 35.6996,
                                    lng: service && service.Longitude ? service.Longitude : (customer && customer.Longtitude) ? customer.Longtitude : 51.3380,
                                    zoom: 9
                                }} />
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='row'>
                                    <div className="form-group col-md-3">
                                        <label>{Number(productGrouppingType) === 1 ? ('نام و مدل محصول') : ('مارک، نوع، مدل محصول')} </label><span style={{ color: "red" }}>*</span>
                                        <input type="hidden" name="ProductID" ref={register({ required: true })} readOnly value={selectedProduct.ProductID ? selectedProduct.ProductID : service && service.ProductID ? service.ProductID : ""} />
                                        <input type="text" placeholder='محصول را انتخاب کنید' className="form-control" style={{ width: '88%', display: 'inline-block' }}
                                            value={selectedProduct.ProductID ? (selectedProduct.HolderName ? selectedProduct.HolderName + "-" : "") + selectedProduct.ProductName + '-' + selectedProduct.ProductModel :
                                                service && service.ProductName ? service.ProductName + '-' + service.ProductModel : ""} readOnly />
                                        <Button className='group-Btn-smalll'
                                            onClick={() => { dispatch(setProductPopup({ status: 'show', setProductData: selectProduct })) }}>
                                            <List size={19} />
                                        </Button>
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label> نوع سرویس </label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                        <select className="form-control" name="ServiceType" ref={register({ required: true })} defaultValue={Number(serviceID) > 0 ? serviceType : ""}>
                                            <option value=""> لطفا انتخاب کنید </option>
                                            <option value="Repair"> تعمیر </option>
                                            <option value="Install"> نصب </option>
                                        </select>
                                        {errors.ServiceType && <small className="errors"> نوع سرویس را وارد کنید </small>}
                                    </div>

                                    <div className="form-group col-md-3">
                                        <label> شماره سریال </label>
                                        <input className="form-control" name="SerialNumber" ref={register({})} type="text"
                                            onChange={e => changeSerial(e.target.value)}
                                            value={service && service.SerialNumber ? service.SerialNumber : selectedProduct.SerialNumber ? selectedProduct.SerialNumber : ""}
                                            style={{ display: "inline-block", width: "88%" }} />
                                        <Button className='group-Btn-smalll' onClick={showSerialHistory}><List size={19} /></Button>
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label> شماره گارانتی </label>
                                        <input className="form-control" name="GuaranteeCardNo" ref={register({})} type="text"
                                            onChange={e => changeCardNo(e.target.value)}
                                            value={service && service.GuarantyCode ? service.GuarantyCode : selectedProduct.GuaranteeCardNo ? selectedProduct.GuaranteeCardNo : ""} />
                                    </div>
                                    <div className="col-md-3 form-group">
                                        <label>تاریخ آغاز گارانتی</label>
                                        <DatePicker isGregorian={false} timePicker={false} className="form-control"
                                            value={service && service.GuaranteeStartDate ? momentJalaali(service.GuaranteeStartDate.substring(0, 10))
                                                : selectedProduct.GuaranteeStartDate ? momentJalaali(selectedProduct.GuaranteeStartDate.substring(0, 10))
                                                    : gDate.current.StartDate ? momentJalaali(gDate.current.StartDate.substring(0, 10)) : null}
                                            onChange={value => { gDate.current.StartDate = value.local("en").format("YYYY/MM/DD") }} />
                                    </div>
                                    <div className='col-md-3 form-group'>
                                        <label>مدت گارانتی(ماه)</label>
                                        <input type='number' className="form-control" onChange={e => addMonth(e.target.value)}
                                            value={service && service.GuaranteeTimeInMonth ? service.GuaranteeTimeInMonth :
                                                selectedProduct.GuaranteeTimeInMonth ? selectedProduct.GuaranteeTimeInMonth : 0} />
                                    </div>
                                    <div className="col-md-3 form-group">
                                        <label>تاریخ پایان گارانتی</label>
                                        <DatePicker isGregorian={false} timePicker={false} className="form-control"
                                            value={gEndDate && gEndDate !== '' ? momentJalaali(gEndDate.substring(0, 10))
                                                :
                                                service && service.GuaranteeEndDate ? momentJalaali(service.GuaranteeEndDate.substring(0, 10)) : null}
                                            onChange={value => { gDate.current.EndDate = value.local("en").format("YYYY/MM/DD") }} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label> نام فروشگاه </label>
                                        <input className="form-control" name="ShopName" ref={register({})} type="text"
                                            defaultValue={service && service.ShopName ? service.ShopName : ""} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label> عیب به اظهار مشتری </label>
                                        <input className="form-control" name="Attr7" ref={register({})} type="text"
                                            defaultValue={service && service.Attr7 ? service.Attr7 : ""} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>نام استان</label>
                                        {provinceList === "PENDING" &&
                                            <div className="form-control">
                                                <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                            </div>
                                        }
                                        {provinceList && Array.isArray(provinceList) &&
                                            <select className="form-control" name="ProvinceID" ref={register({ required: true })}
                                                defaultValue={service && service.ProvinceID ? service.ProvinceID : customer && customer.ProvinceID ? customer.ProvinceID : ""}
                                                onChange={e => onProvinceChanged(e.target.value)}>
                                                <option value="">انتخاب کنید</option>
                                                {provinceList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                            </select>
                                        }
                                        {errors.ProvinceID && <small className="errors">نام استان اجباری است</small>}

                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>نام شهر</label>
                                        {cityList === "PENDING" &&
                                            <div className="form-control">
                                                <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                            </div>
                                        }
                                        {cityList && Array.isArray(cityList) &&
                                            <select className="form-control" name="CityID" ref={register({ required: true })}
                                                onChange={e => onCityChanged(e.target.value)}
                                                defaultValue={service && service.CityID ? service.CityID : customer && customer.CityID ? customer.CityID : ""}>
                                                <option value="">انتخاب کنید</option>
                                                {locationCmbClicked.current &&
                                                    cityList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)
                                                }
                                                {!locationCmbClicked.current && service && service.CityID &&
                                                    <option value={service.CityID}>{service.CityName}</option>
                                                }
                                                {!locationCmbClicked.current && (!service || !service.CityID) && (customer && customer.CityID) &&
                                                    <option value={customer.CityID}>{customer.City}</option>
                                                }
                                            </select>}
                                        {errors.CityID && <small className="errors">نام شهر اجباری است</small>}
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>نام منطقه</label>
                                        {zoneList === "PENDING" &&
                                            <div className="form-control">
                                                <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                            </div>
                                        }
                                        {zoneList && Array.isArray(zoneList) &&
                                            <select className="form-control" name="ZoneID" ref={register({})}
                                                defaultValue={service && service.ZoneID ? service.ZoneID : customer && customer.ZoneID ? customer.ZoneID : ""}>
                                                <option value="">انتخاب کنید</option>
                                                {locationCmbClicked.current && zoneList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                                {!locationCmbClicked.current && service && service.ZoneID &&
                                                    <option value={service.ZoneID}>{service.ZoneName}</option>
                                                }
                                                {!locationCmbClicked.current && (!service || !service.ZoneID) &&
                                                    customer && customer.ZoneID &&
                                                    <option value={customer.ZoneID}>{customer.Zone}</option>
                                                }
                                            </select>
                                        }
                                        {errors.ZoneID && <small className="errors">منطقه جفرافیایی اجباری است</small>}
                                    </div>

                                    <div className="form-group col-md-3">
                                        <label> آدرس محل مراجعه تکنسین </label>
                                        <input className="form-control" name="ServiceAddress" ref={register({})} type="text"
                                            style={{ width: "88%", display: "inline-block" }}
                                            defaultValue={service && service.ServiceAddress ? service.ServiceAddress : customer && customer.Address ? customer.Address : ""} />
                                        <Button className='group-Btn-smalll' onClick={() => dispatch(setMapPop({ show: true }))}><GeoAltFill size={19} /></Button>
                                        {errors.ServiceAddress && <small className="errors"> آدرس اجباری است </small>}
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label> توضیحات </label>
                                        <input className="form-control" name="Description" ref={register({})} type="text"
                                            defaultValue={service && service.Description ? service.Description : ""} />
                                    </div>
                                </div>
                                {Number(serviceID) > 0 &&
                                    <div className='row mt-2'>
                                        <div className='col-md-6'>
                                            <label style={{ fontWeight: "bold", color: "blue" }}>پیام های داخلی</label>
                                            <hr style={{ marginTop: "2px", marginBottom: "8px", height: "3px", color: "blue" }} />
                                            <div className='form-group' style={{ marginTop: "2px" }}>
                                                <Form.Control as="textarea" rows={1} style={{ width: "85%", display: "inline-block" }}
                                                    onChange={e => message.current = e.target.value} />
                                                <Button className='group-Btn' style={{ marginTop: "-30px" }} onClick={addMessage}><PlusSquare size={18} /></Button>
                                            </div>
                                            <Table responsive className='fixedTable' style={{ marginBottom: "0px" }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: window.innerWidth >= 414 ? "40%" : "60%" }}>متن پیام</th>
                                                        <th style={{ width: window.innerWidth >= 414 ? "15%" : "30%" }}>تاریخ ثبت</th>
                                                        {window.innerWidth >= 414 &&
                                                            <Fragment>
                                                                <th style={{ width: "20%" }}>ثبت کننده</th>
                                                                <th style={{ width: "15%" }}>سمت</th>
                                                            </Fragment>
                                                        }
                                                        <th style={{ width: "10%" }}>&nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {messageList === "PENDING" &&
                                                        <tr>
                                                            <td colSpan={4} style={{ textAlign: "center" }}><Loader type="BallTriangle" width={20} height={20} /></td>
                                                        </tr>
                                                    }
                                                    {messageList && Array.isArray(messageList) &&
                                                        messageList.map((item, i) =>
                                                            <tr key={i} className="resultTableRow">
                                                                <td style={{ width: window.innerWidth >= 414 ? "40%" : "60%" }}>{item.MessageBody}</td>
                                                                <td style={{ width: window.innerWidth >= 414 ? "15%" : "30%" }}>{item.PCreationDate}</td>
                                                                {window.innerWidth >= 414 &&
                                                                    <Fragment>
                                                                        <td style={{ width: "20%" }}>{item.CreateByName}</td>
                                                                        <td style={{ width: "15%" }}>{item.DepartmentName}</td>
                                                                    </Fragment>
                                                                }
                                                                <td style={{ width: "10%" }} onClick={() => {
                                                                    dispatch(setDialog({
                                                                        status: 'show',
                                                                        arrayBtn: ['yes', 'no'],
                                                                        dialogTitle: 'حذف پیام',
                                                                        dialogText: 'آیا از حذف مطمئن هستید؟',
                                                                        okOperation: deleteMessage(item.ID, () => { dispatch(getMessageList(serviceType, serviceID)) })
                                                                    }))
                                                                }}><Trash size={16} style={{ color: "red" }} className="rowBtn" /></td>
                                                            </tr>)
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                }

                                {!(Number(serviceID) > 0) && !pending &&
                                    <Button type="submit" variant='success' className='group-Btn mt-2'><CheckLg />&nbsp;ثبت سرویس</Button>
                                }
                                {!(Number(serviceID) > 0) && pending &&
                                    <Loader type="BallTriangle" width={25} height={25} />
                                }
                                {
                                    Number(serviceID) > 0 &&
                                    <Fragment>
                                        <Button className='group-Btn mt-2' onClick={showCommand}><Command />&nbsp;دستور کار</Button>
                                    </Fragment>
                                }
                            </form>
                        </div>
                    </div>
                }
            </div>
        </Fragment>
    )
}
export default AddEditCustomerService;